import React, { useLayoutEffect, useRef } from "react";
import Chart from "chart.js/auto";
import "./dashboard.css";

const TotalCompaniesGraph = () => {
  const chartRef = useRef(null);
  const chartInstanceRef = useRef(null);

  useLayoutEffect(() => {
    if (!chartRef.current) return; // Ensure canvas exists
    const ctx = chartRef.current.getContext("2d");

    const gradient = ctx.createLinearGradient(0, 0, 0, 400);
    gradient.addColorStop(0, "rgba(13, 148, 136, 0.35)");
    gradient.addColorStop(1, "rgba(255, 255, 255, 0)");

    const originalData = [
      52, 52, 62, 52, 58, 55, 82, 53, 55, 70, 67, 64, 54, 61, 53, 59,
    ];
    const labelMap = ["40", "50", "60", "80", "100"];

    const mappedData = originalData.map((val) => {
      if (val <= 45) return 0;
      if (val <= 55) return 1;
      if (val <= 70) return 2;
      if (val <= 90) return 3;
      return 4;
    });

    const lineData = {
      labels: [11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26],
      datasets: [
        {
          label: "Total Companies",
          data: mappedData,
          fill: true,
          backgroundColor: gradient,
          borderColor: "rgba(13, 148, 136, 0.9)",
          borderWidth: 2,
          tension: 0,
          pointRadius: 0,
          pointHoverRadius: 6,
          pointHitRadius: 10,
          pointBackgroundColor: "#0D9488",
          pointBorderWidth: 2,
        },
      ],
    };

    const options = {
      responsive: true,
      maintainAspectRatio: false,
      scales: {
        y: {
          type: "linear",
          min: 0,
          max: 4,
          ticks: {
            stepSize: 1,
            callback: (value) => labelMap[value] || "",
            color: "#9ca3af",
            font: { size: 14 },
          },
          grid: {
            color: "rgba(0,0,0,0.1)",
            drawBorder: false,
            drawTicks: false,
          },
        },
        x: {
          ticks: { color: "#64748B", font: { size: 12 } },
          grid: { display: false },
        },
      },
      plugins: {
        legend: { display: false },
        tooltip: {
          callbacks: {
            label: (context) => ` ${labelMap[context.raw]} Companies`,
          },
          backgroundColor: "#0D9488",
          titleColor: "#fff",
          bodyColor: "#fff",
          borderColor: "#0F766E",
          borderWidth: 1,
          padding: 10,
          displayColors: false,
        },
      },
    };

    if (chartInstanceRef.current) chartInstanceRef.current.destroy();
    chartInstanceRef.current = new Chart(ctx, {
      type: "line",
      data: lineData,
      options,
    });
  }, []);

  return (
    <div className="chart-card">
      <div className="chart-header">
        <h2 className="chart-title">Total Companies</h2>
        <select className="chart-dropdown">
          <option>This Month</option>
          <option>Last Month</option>
        </select>
      </div>
      <div className="chart-body">
        <canvas ref={chartRef}></canvas>
      </div>
    </div>
  );
};

export default TotalCompaniesGraph;
